import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { AllGamesComponent } from './pages/all-games/all-games.component';
import { FaqComponent } from './pages/faq/faq.component';
import { HomeComponent } from './pages/home/home.component';
import { MyAccountComponent } from './pages/my-account/my-account.component';
import { TncComponent } from './pages/tnc/tnc.component';
import { CategoryComponent } from './pages/category/category.component';
import { GamePlayComponent } from './pages/game-play/game-play.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { LpComponent } from './pages/lp/lp.component';
import { ViewGamesComponent } from './pages/view-games/view-games.component';
import { TestComponent } from './pages/test/test.component';
import { SplashComponent } from './pages/splash/splash.component';
import { MsisdnComponent } from './pages/msisdn/msisdn.component';
import { LoadingComponent } from './pages/loading/loading.component';

const routes: Routes = [
  { path: 'home', component: HomeComponent, },
  { path: 'all-games', component: AllGamesComponent, },
  { path: 'view-games/:id/:name', component: ViewGamesComponent, },
  { path: 'my-account', component: MyAccountComponent, },
  { path: 'tnc', component: TncComponent, },
  { path: 'faq', component: FaqComponent, },
  { path: 'privacy-policy', component: PrivacyPolicyComponent, },
  { path: 'home/category/:title', component: CategoryComponent },
  { path: 'game-play', component: GamePlayComponent },
  { path: 'game-play/:id/:page', component: GamePlayComponent },
  { path: 'lp', component: LpComponent },
  { path: 'splash', component: SplashComponent },
  { path: 'test', component: TestComponent },
  { path: 'msisdn', component: MsisdnComponent },
  { path: 'loading', component: LoadingComponent },
  { path: '', redirectTo: 'home', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
